module.exports = __webpack_public_path__ + "static/Irstrat1-bd80e11e63fdb8fe2ee3edf357b0daa6.png";